import React from "react";
import { countryList } from "../../../utils/constants";

function CountrySelect({
  country,
  setCountry,
  keyField,
  formik,
  label,
  required = true,
  hideOptional = false,
  disabled = false,
  readOnly = false,
  whitelist = ["US", "CA"],
}) {

  const handleChange = (e) => {
    const val = e.target.value;
    setCountry && setCountry(val);
    formik.setFieldValue(keyField, val);
  };

  // filter countries using whitelist (same behavior as library)
  const filteredCountries = countryList.filter((c) =>
    whitelist.includes(c.value)
  );

  return (
    <div className="field-wrap">
      <label htmlFor={keyField}>
        {label}
        {required ? (
          <span style={{ color: "red" }}> *</span>
        ) : hideOptional ? (
          ""
        ) : (
          " (Optional)"
        )}
      </label>

      <select
        id={keyField}
        name={keyField}
        value={country || formik?.values?.[keyField] || ""}
        onChange={handleChange}
        onBlur={formik.handleBlur}
        disabled={disabled || readOnly}
        className="form-control"
        style={{ cursor: readOnly ? "auto" : "pointer" }}
      >
        <option value="">Select Country</option>

        {filteredCountries.map((c) => (
          <option key={c.value} value={c.value}>
            {c.name}
          </option>
        ))}
      </select>

      {formik?.touched[keyField] && formik?.errors[keyField] && (
        <div className="error-text">{formik?.errors[keyField]}</div>
      )}
    </div>
  );
}

export default CountrySelect;
